import { GridColumn } from 'src/components/GridWrapper';
import RedirectToInvoiceDetails from 'src/sections/enter_invoice/RedirectInvoiceDetails';
import InfoButton from 'src/sections/enter_receipt/custom_grid_cell/InfoButton';
import OfflineSupplierCell from 'src/sections/enter_receipt/custom_grid_cell/cells/OfflineSupplierCell';

export const invoiceColumns: GridColumn<any>[] = [
  {
    field: 'errors',
    title: '',
    width: 40,
    component: InfoButton,
    menu: false,
  },
  {
    field: 'invoiceNumber',
    title: 'Documents #',
    filter: 'text',
    dataType: 'string',
    component: RedirectToInvoiceDetails,
  },
  {
    field: 'status',
    title: 'Status',
    filter: 'text',
    dataType: 'string',
    component: OfflineSupplierCell,
  },
  {
    field: 'companyName',
    title: 'Company Name',
    filter: 'text',
    dataType: 'string',
    component: OfflineSupplierCell,
  },
  {
    field: 'buyerName',
    title: 'Buyer Name',
    filter: 'text',
    dataType: 'string',
    component: OfflineSupplierCell,
  },
  {
    field: 'statusDate',
    title: 'Status Date',
    filter: 'date',
    format: '{0:MM/dd/yyyy}',
    dataType: 'date',
    component: OfflineSupplierCell,
  },
  {
    field: 'supplierName',
    title: 'Supplier Name',
    filter: 'text',
    dataType: 'string',
    component: OfflineSupplierCell,
  },
  {
    field: 'totalCostAmt',
    title: 'Document Total',
    filter: 'numeric',
    format: '{0:c}',
    dataType: 'dollar',
    filterFormat: 'c',
  },
  {
    field: 'poTotal',
    title: 'PO Total',
    filter: 'numeric',
    format: '{0:c}',
    dataType: 'dollar',
    filterFormat: 'c',
  },
];
